import React from 'react'
import ContactForm from './ContactForm'
import { BiLogoWhatsapp } from "react-icons/bi";

function ContactPage() {
  return (
    <section id="home" className="d-flex align-items-center homePage">
      <a target="_blank" rel="noreferrer" href="https://api.whatsapp.com/send?phone=919535117707&text=Hi, Hoolla's Trekking!" class="whatsapp-button"><BiLogoWhatsapp/></a>
      <div className="container">
        <div className="row">
        <h3 className="fontColor-1 aboutInOther">CONTACT US</h3>
          <div className="col-lg-6 order-2 order-lg-1 d-flex flex-column justify-content-center">
            <div className='contactSection'>
                <div className="testimonial-card">
                    <p className='trekLine'><i className="fas fa-phone icon-color" aria-hidden="true"></i>&nbsp; Phone : +91-9535XXXXXX</p>
                    <p className='trekLine'><i className="fas fa-envelope icon-color" aria-hidden="true"></i>&nbsp; Email : contact@hollastrekking.in</p>
                    <p className='trekLine'><i className="fas fa-map-marker icon-color" aria-hidden="true"></i>&nbsp; Office : Indiranagara, Bengaluru - 560038</p>
                </div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15551.93069203467!2d77.62793440938603!3d12.97295995758582!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae16a418770391%3A0xb50f46b826501036!2sIndiranagar%2C%20Bengaluru%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1708147929236!5m2!1sen!2sin" height={310} width={425}/>    
            </div>
          </div>
          <div className="col-lg-6 order-2 order-lg-1 d-flex flex-column justify-content-center contactForm">
          <ContactForm/>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactPage
